var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h2',{staticClass:"title",style:({
    fontSize: _vm.info.form.fontSize + 'px',
    color: _vm.info.form.color,
    backgroundColor: _vm.info.form.backgroundColor,
    })},[_vm._v(" "+_vm._s(_vm.info.form.text)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }